// extracted by mini-css-extract-plugin
export default {"root":"SourceView_root__izxP3","header":"SourceView_header__4sbqs","body":"SourceView_body__PCfDw"};